// require('../src/javascript/landing/home');
//import AOS from 'aos';
import Masonry from 'masonry-layout';
import LazyLoad from "vanilla-lazyload";


//import 'aos/dist/aos.css';

import '../src/stylesheets/pages/landing';

require.context('../images', true);

const Turbolinks = require('turbolinks');

Turbolinks.start();

$(document).on('turbolinks:load', function() {

  new LazyLoad({
    elements_selector: ".lazy",
  });

 /* AOS.init({
    startEvent: 'load',
    disable: 'mobile'
  });*/ 


  if ($('.grid').length){

  let elem = document.querySelector('.grid');

  new Masonry(elem, {
    // options
    itemSelector: '.grid-item',
    columnWidth: 266,
    gutter: 30,
    horizontalOrder: true,
    fitWidth: true,
    resize: true,
    isAnimated: true
  });

}
  
});
